import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class AppDataSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success =
      serverRes.statusCode == 200 ||
      serverRes.statusCode == 201 ||
      serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: ADS_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }

    const savedData = serverRes?.data?.appInfo;
    // savedData?.general?.instagramLink,

    return {
      statuCode: 200,
      success: true,
      message: 'Ads got',
      data: {
        general: {
          withdrawVideoLink: savedData?.general?.withdrawVideoLink || '',
          withdrawTutorialLink: savedData?.general?.withdrawTutorialLink || '',
          rechargeVideoLink: savedData?.general?.rechargeVideoLink || '',
          rechargeTutorialLink: savedData?.general?.rechargeTutorialLink || '',
          facebookLink: savedData?.general?.facebookLink || '',
          instagramLink: savedData?.general?.instagramLink || '',
          tiktokLink: savedData?.general?.tiktokLink || '',
          websiteLink: savedData?.general?.websiteLink || '',
          affiliationDetailText:
            savedData?.general?.affiliationDetailText || '',
          whatsappComplaintLink:
            savedData?.general?.whatsappComplaintLink || '',
          passwordResetUrl: savedData?.general?.passwordResetUrl || '',
          faqUrl: savedData?.general?.faqUrl || '',
          policyUrl: savedData?.general?.policyUrl || '',
          cguUrl: savedData?.general?.cguUrl || '',
          email: savedData?.general?.email || '',
          rechargeVideoLink: savedData?.general?.rechargeVideoLink || '',
          rechargeTutorialLink: savedData?.general?.rechargeTutorialLink || '',
          snapchatLink: savedData?.general?.snapchatLink || '',
          userCurrency: savedData?.general?.userCurrency || '',
          minAmountForTransaction:
            savedData?.general?.minAmountForTransaction || '',
          minAmountBuyXbet: savedData?.general?.minAmountBuyXbet || '',
          minAmountSellXbet: savedData?.general?.minAmountSellXbet || '',
          minAmountBuyBetwinner:
            savedData?.general?.minAmountBuyBetwinner || '',
          minAmountSellBetwinner:
            savedData?.general?.minAmountSellBetwinner || '',
          minAmountBuyPm: savedData?.general?.minAmountBuyPm || '',
          minAmountSellPm: savedData?.general?.minAmountSellPm || '',
          minAmountBuyUsdt: savedData?.general?.minAmountBuyUsdt || '',
          minAmountSellUsdt: savedData?.general?.minAmountSellUsdt || '',
          telegramLink: savedData?.general?.telegramLink || '',
          minAmountBuyOneWin: savedData?.general?.minAmountBuyOneWin || '',
          minAmountSellOneWin: savedData?.general?.minAmountSellOneWin || '',
          minAmountFundWallet: savedData?.general?.minAmountFundWallet || '',
          minAmountwithdrawalWallet:
            savedData?.general?.minAmountwithdrawalWallet || '',
          whatsappAssistanceLink:
            savedData?.general?.whatsappAssistanceLink || '',
          telegramAssistanceLink:
            savedData?.general?.telegramAssistanceLink || '',
          netflixDownloadUrl: savedData?.general?.netflixDownloadUrl || '',
          crunchyrolDownloadUrl:
            savedData?.general?.crunchyrolDownloadUrl || '',
          xbetDownloadUrl: savedData?.general?.xbetDownloadUrl || '',
          betwinnerDownloadUrl: savedData?.general?.betwinnerDownloadUrl || '',
          oneWinDownloadUrl: savedData?.general?.oneWinDownloadUrl || '',
          primeVideoDownloadUrl:
            savedData?.general?.primeVideoDownloadUrl || '',
          spotifyDownloadUrl: savedData?.general?.spotifyDownloadUrl || '',
          nordVPNDownloadUrl: savedData?.general?.nordVPNDownloadUrl || '',
          privateVPNDownloadUrl:
            savedData?.general?.privateVPNDownloadUrl || '',
          cyberGhostDownloadUrl:
            savedData?.general?.cyberGhostDownloadUrl || '',
          whatsappLink: savedData?.general?.whatsappLink || '',
          mailWhatsapp: savedData?.general?.mailWhatsapp || '',
          minAmountBuyEightStarz:
            savedData?.general?.minAmountBuyEightStarz || 0,
          minAmountSellEightStarz:
            savedData?.general?.minAmountSellEightStarz || 0,
          minAmountSellMelbet: savedData?.general?.minAmountSellMelbet || 0,
          minAmountBuyMelbet: savedData?.general?.minAmountBuyMelbet || 0
        },
        contacts: {
          GA: {
            whatsappPhoneNumber:
              savedData?.contacts?.GA?.whatsappPhoneNumber || '',
            whatsappPhoneNumberComplaint:
              savedData?.contacts?.GA?.whatsappPhoneNumberComplaint || '',
            whatsappLink: savedData?.contacts?.GA?.whatsappLink || '',
            whatsappChatLink: savedData?.contacts?.GA?.whatsappChatLink || '',
            telegramLink: savedData?.contacts?.GA?.telegramLink || ''
          },
          ALL: {
            whatsappPhoneNumber:
              savedData?.contacts?.ALL?.whatsappPhoneNumber || '',
            whatsappPhoneNumberComplaint:
              savedData?.contacts?.ALL?.whatsappPhoneNumberComplaint || '',
            whatsappLink: savedData?.contacts?.ALL?.whatsappLink || '',
            whatsappChatLink: savedData?.contacts?.ALL?.whatsappChatLink || '',
            telegramLink: savedData?.contacts?.ALL?.telegramLink || ''
          }
        },
        rates: {
          BJ: {
            buyRates: {
              USDT: {
                XOF: savedData?.rates?.BJ?.buyRates?.USDT?.XOF || 0
              }
            },
            sellRates: {
              USDT: {
                XOF: savedData?.rates?.BJ?.sellRates?.USDT?.XOF || 0
              }
            }
          },
          BF: {
            buyRates: {
              USDT: {
                XOF: savedData?.rates?.BF?.buyRates?.USDT?.XOF || 0
              }
            },
            sellRates: {
              USDT: {
                XOF: savedData?.rates?.BF?.sellRates?.USDT?.XOF || 0
              }
            }
          },
          CI: {
            buyRates: {
              USDT: {
                XOF: savedData?.rates?.CI?.buyRates?.USDT?.XOF || 0
              }
            },
            sellRates: {
              USDT: {
                XOF: savedData?.rates?.CI?.sellRates?.USDT?.XOF || 0
              }
            }
          },
          GA: {
            buyRates: {
              USDT: {
                XAF: savedData?.rates?.GA?.buyRates?.USDT?.XAF || 0
              }
            },
            sellRates: {
              USDT: {
                XAF: savedData?.rates?.GA?.sellRates?.USDT?.XAF || 0
              }
            }
          },
          ML: {
            buyRates: {
              USDT: {
                XOF: savedData?.rates?.ML?.buyRates?.USDT?.XOF || 0
              }
            },
            sellRates: {
              USDT: {
                XOF: savedData?.rates?.ML?.sellRates?.USDT?.XOF || 0
              }
            }
          },
          NE: {
            buyRates: {
              USDT: {
                XOF: savedData?.rates?.NE?.buyRates?.USDT?.XOF || 0
              }
            },
            sellRates: {
              USDT: {
                XOF: savedData?.rates?.NE?.sellRates?.USDT?.XOF || 0
              }
            }
          },
          SN: {
            buyRates: {
              USDT: {
                XOF: savedData?.rates?.SN?.buyRates?.USDT?.XOF || 0
              }
            },
            sellRates: {
              USDT: {
                XOF: savedData?.rates?.SN?.sellRates?.USDT?.XOF || 0
              }
            }
          },
          TG: {
            buyRates: {
              USDT: {
                XOF: savedData?.rates?.TG?.buyRates?.USDT?.XOF || 0
              }
            },
            sellRates: {
              USDT: {
                XOF: savedData?.rates?.TG?.sellRates?.USDT?.XOF || 0
              }
            }
          }
        },
        paymentOtpUssdCode: {
          ML: {
            text: savedData?.paymentOtpUssdCode?.ML?.text || '',
            ussdCode: savedData?.paymentOtpUssdCode?.ML?.ussdCode || ''
          },
          BF: {
            text: savedData?.paymentOtpUssdCode?.BF?.text || '',
            ussdCode: savedData?.paymentOtpUssdCode?.BF?.ussdCode || ''
          },
          SN: {
            text: savedData?.paymentOtpUssdCode?.SN?.text || '',
            ussdCode: savedData?.paymentOtpUssdCode?.SN?.ussdCode || ''
          },
          CI: {
            text: savedData?.paymentOtpUssdCode?.CI?.text || '',
            ussdCode: savedData?.paymentOtpUssdCode?.CI?.ussdCode || ''
          }
        },
        addresses: {
          BJ: {
            usdtTrc20Address: savedData?.addresses?.BJ?.usdtTrc20Address || '',
            usdtErc20Address: savedData?.addresses?.BJ?.usdtErc20Address || '',
            usdtBep20Address: savedData?.addresses?.BJ?.usdtBep20Address || '',
            binanceAccountId: savedData?.addresses?.BJ?.binanceAccountId || '',
            betwinnerWithdrawAddress:
              savedData?.addresses?.BJ?.betwinnerWithdrawAddressString || '',
            melbetWithdrawAddress:
              savedData?.addresses?.BJ?.melbetWithdrawAddressString || '',
            eightStarzWithdrawAddress:
              savedData?.addresses?.BJ?.eightStarzWithdrawAddressString || '',
            oneWinWithdrawAddress:
              savedData?.addresses?.BJ?.oneWinWithdrawAddressString || '',
            xbetWithdrawAddress:
              savedData?.addresses?.BJ?.xbetWithdrawAddressString || ''
          },
          BF: {
            usdtTrc20Address: savedData?.addresses?.BF?.usdtTrc20Address || '',
            usdtErc20Address: savedData?.addresses?.BF?.usdtErc20Address || '',
            usdtBep20Address: savedData?.addresses?.BF?.usdtBep20Address || '',
            binanceAccountId: savedData?.addresses?.BF?.binanceAccountId || '',
            betwinnerWithdrawAddress:
              savedData?.addresses?.BF?.betwinnerWithdrawAddressString || '',
            melbetWithdrawAddress:
              savedData?.addresses?.BF?.melbetWithdrawAddressString || '',
            eightStarzWithdrawAddress:
              savedData?.addresses?.BF?.eightStarzWithdrawAddressString || '',
            oneWinWithdrawAddress:
              savedData?.addresses?.BF?.oneWinWithdrawAddressString || '',
            xbetWithdrawAddress:
              savedData?.addresses?.BF?.xbetWithdrawAddressString || ''
          },
          NE: {
            usdtTrc20Address: savedData?.addresses?.NE?.usdtTrc20Address || '',
            usdtErc20Address: savedData?.addresses?.NE?.usdtErc20Address || '',
            usdtBep20Address: savedData?.addresses?.NE?.usdtBep20Address || '',
            binanceAccountId: savedData?.addresses?.NE?.binanceAccountId || '',
            betwinnerWithdrawAddress:
              savedData?.addresses?.NE?.betwinnerWithdrawAddressString || '',
            melbetWithdrawAddress:
              savedData?.addresses?.NE?.melbetWithdrawAddressString || '',
            eightStarzWithdrawAddress:
              savedData?.addresses?.NE?.eightStarzWithdrawAddressString || '',
            oneWinWithdrawAddress:
              savedData?.addresses?.NE?.oneWinWithdrawAddressString || '',
            xbetWithdrawAddress:
              savedData?.addresses?.NE?.xbetWithdrawAddressString || ''
          },
          GA: {
            usdtTrc20Address: savedData?.addresses?.GA?.usdtTrc20Address || '',
            usdtErc20Address: savedData?.addresses?.GA?.usdtErc20Address || '',
            usdtBep20Address: savedData?.addresses?.GA?.usdtBep20Address || '',
            binanceAccountId: savedData?.addresses?.GA?.binanceAccountId || '',
            betwinnerWithdrawAddress:
              savedData?.addresses?.GA?.betwinnerWithdrawAddressString || '',
            melbetWithdrawAddress:
              savedData?.addresses?.GA?.melbetWithdrawAddressString || '',
            eightStarzWithdrawAddress:
              savedData?.addresses?.GA?.eightStarzWithdrawAddressString || '',
            oneWinWithdrawAddress:
              savedData?.addresses?.GA?.oneWinWithdrawAddressString || '',
            xbetWithdrawAddress:
              savedData?.addresses?.GA?.xbetWithdrawAddressString || ''
          },
          TG: {
            usdtTrc20Address: savedData?.addresses?.TG?.usdtTrc20Address || '',
            usdtErc20Address: savedData?.addresses?.TG?.usdtErc20Address || '',
            usdtBep20Address: savedData?.addresses?.TG?.usdtBep20Address || '',
            binanceAccountId: savedData?.addresses?.TG?.binanceAccountId || '',
            betwinnerWithdrawAddress:
              savedData?.addresses?.TG?.betwinnerWithdrawAddressString || '',
            melbetWithdrawAddress:
              savedData?.addresses?.TG?.melbetWithdrawAddressString || '',
            eightStarzWithdrawAddress:
              savedData?.addresses?.TG?.eightStarzWithdrawAddressString || '',
            oneWinWithdrawAddress:
              savedData?.addresses?.TG?.oneWinWithdrawAddressString || '',
            xbetWithdrawAddress:
              savedData?.addresses?.TG?.xbetWithdrawAddressString || ''
          },
          SN: {
            usdtTrc20Address: savedData?.addresses?.SN?.usdtTrc20Address || '',
            usdtErc20Address: savedData?.addresses?.SN?.usdtErc20Address || '',
            usdtBep20Address: savedData?.addresses?.SN?.usdtBep20Address || '',
            binanceAccountId: savedData?.addresses?.SN?.binanceAccountId || '',
            betwinnerWithdrawAddress:
              savedData?.addresses?.SN?.betwinnerWithdrawAddressString || '',
            melbetWithdrawAddress:
              savedData?.addresses?.SN?.melbetWithdrawAddressString || '',
            eightStarzWithdrawAddress:
              savedData?.addresses?.SN?.eightStarzWithdrawAddressString || '',
            oneWinWithdrawAddress:
              savedData?.addresses?.SN?.oneWinWithdrawAddressString || '',
            xbetWithdrawAddress:
              savedData?.addresses?.SN?.xbetWithdrawAddressString || ''
          },
          ML: {
            usdtTrc20Address: savedData?.addresses?.ML?.usdtTrc20Address || '',
            usdtErc20Address: savedData?.addresses?.ML?.usdtErc20Address || '',
            usdtBep20Address: savedData?.addresses?.ML?.usdtBep20Address || '',
            binanceAccountId: savedData?.addresses?.ML?.binanceAccountId || '',
            betwinnerWithdrawAddress:
              savedData?.addresses?.ML?.betwinnerWithdrawAddressString || '',
            melbetWithdrawAddress:
              savedData?.addresses?.ML?.melbetWithdrawAddressString || '',
            eightStarzWithdrawAddress:
              savedData?.addresses?.ML?.eightStarzWithdrawAddressString || '',
            oneWinWithdrawAddress:
              savedData?.addresses?.ML?.oneWinWithdrawAddressString || '',
            xbetWithdrawAddress:
              savedData?.addresses?.ML?.xbetWithdrawAddressString || ''
          },
          CI: {
            usdtTrc20Address: savedData?.addresses?.CI?.usdtTrc20Address || '',
            usdtErc20Address: savedData?.addresses?.CI?.usdtErc20Address || '',
            usdtBep20Address: savedData?.addresses?.CI?.usdtBep20Address || '',
            binanceAccountId: savedData?.addresses?.CI?.binanceAccountId || '',
            betwinnerWithdrawAddress:
              savedData?.addresses?.CI?.betwinnerWithdrawAddressString || '',
            melbetWithdrawAddress:
              savedData?.addresses?.CI?.melbetWithdrawAddressString || '',
            eightStarzWithdrawAddress:
              savedData?.addresses?.CI?.eightStarzWithdrawAddressString || '',
            oneWinWithdrawAddress:
              savedData?.addresses?.CI?.oneWinWithdrawAddressString || '',
            xbetWithdrawAddress:
              savedData?.addresses?.CI?.xbetWithdrawAddressString || ''
          }
        },
        coupons: {
          vipCouponsEnablingText:
            savedData?.coupons?.vipCouponsEnablingText || '',
          vipCouponsAllowed: savedData?.coupons?.vipCouponsAllowed || false,
          vipAmountDone: savedData?.coupons?.vipAmountDone || 0,
          vipAmountRequired: savedData?.coupons?.vipAmountRequired || 0,
          couponBannerPicture: savedData?.coupons?.couponBannerPicture || ''
        },
        paymentProviders: savedData?.paymentProviders || {},
        manualOperationsInstructions: savedData?.manualOperationsInstructions || []
      }
    };
  }

  serialize(newData, currentData) {
    // Fusion profonde pour chaque section
    const mergedData = {
      general: {
        ...(currentData.general || {}),
        ...(newData.general || {})
      },
      contacts: this.deepMergeContacts(currentData.contacts || {}, newData.contacts || {}),
      rates: this.deepMergeRates(currentData.rates || {}, newData.rates || {}),
      paymentOtpUssdCode: this.deepMergeByCountry(currentData.paymentOtpUssdCode || {}, newData.paymentOtpUssdCode || {}),
      addresses: this.deepMergeAddresses(currentData.addresses || {}, newData.addresses || {}),
      coupons: {
        ...(currentData.coupons || {}),
        ...(newData.coupons || {})
      },
      paymentProviders: this.deepMergePaymentProviders(currentData.paymentProviders || {}, newData.paymentProviders || {}),
      manualOperationsInstructions: newData.manualOperationsInstructions !== undefined ? newData.manualOperationsInstructions : (currentData.manualOperationsInstructions || [])
    };

    return {
      appInfo: mergedData
    };
  }

  deepMergeContacts(current, newContacts) {
    const merged = { ...current };
    Object.keys(newContacts).forEach((country) => {
      if (!merged[country]) {
        merged[country] = { ...newContacts[country] };
      } else {
        merged[country] = {
          ...merged[country],
          ...newContacts[country]
        };
      }
    });
    return merged;
  }

  deepMergeRates(current, newRates) {
    const merged = { ...current };
    Object.keys(newRates).forEach((country) => {
      if (!merged[country]) {
        merged[country] = { ...newRates[country] };
      } else {
        merged[country] = {
          buyRates: {
            ...(merged[country].buyRates || {}),
            ...(newRates[country].buyRates || {})
          },
          sellRates: {
            ...(merged[country].sellRates || {}),
            ...(newRates[country].sellRates || {})
          }
        };
      }
    });
    return merged;
  }

  deepMergeByCountry(current, newUssd) {
    const merged = { ...current };
    Object.keys(newUssd).forEach((country) => {
      if (!merged[country]) {
        merged[country] = { ...newUssd[country] };
      } else {
        merged[country] = {
          ...merged[country],
          ...newUssd[country]
        };
      }
    });
    return merged;
  }

  deepMergeAddresses(current, newAddresses) {
    const merged = { ...current };
    Object.keys(newAddresses).forEach((country) => {
      if (!merged[country]) {
        merged[country] = { ...newAddresses[country] };
      } else {
        merged[country] = {
          ...merged[country],
          ...newAddresses[country]
        };
      }
    });
    return merged;
  }

  deepMergePaymentProviders(current, newProviders) {
    const merged = { ...current };
    Object.keys(newProviders).forEach((country) => {
      if (!merged[country]) {
        merged[country] = { ...newProviders[country] };
      } else {
        merged[country] = { ...merged[country] };
        Object.keys(newProviders[country]).forEach((provider) => {
          if (!merged[country][provider]) {
            merged[country][provider] = { ...newProviders[country][provider] };
          } else {
            merged[country][provider] = {
              ...merged[country][provider],
              ...newProviders[country][provider]
            };
          }
        });
      }
    });
    return merged;
  }
}

export const serializer = new AppDataSerializer();
